import React, { useState } from "react";
import { getFormattedNumber } from "../utils/textUtils";
import { getInventoryItemSummary } from "../../services/Settings/WarehouseService";
import { Modal } from "react-bootstrap";

// storeId: store uuid, "unassigned", or "" for all stores. Passed through to the batch popup so it shows the same store.
const InventorySummary = ({ resPacket, warehouse, storeId = "" }) => {
    const [show, setShow] = useState({ visible: false, info: [] });
    const groupedByItem = resPacket.reduce((acc, item) => {
        if (!acc[item.itemId]) {
            acc[item.itemId] = {
                itemTitle: item.itemTitle,
                warehouses: {},
            };
        }
        acc[item.itemId].warehouses[item.warehouseTitle] = item;
        return acc;
    }, {});

    // Hide items that have no stock in any of the selected warehouses
    const hasStock = (row) =>
        Number(row?.totalStockInOpenUnit || 0) !== 0 ||
        Number(row?.currentStockBoxQuantity || 0) !== 0 ||
        Number(row?.currentStockOpenQuantity || 0) !== 0;
    Object.keys(groupedByItem).forEach((id) => {
        if (!Object.values(groupedByItem[id].warehouses).some(hasStock)) {
            delete groupedByItem[id];
        }
    });

    const warehouses = [...new Set(resPacket.map((item) => item.warehouseTitle))];
    const handleSowDetails = (uuid) => {
        const payload = {
            itemId: uuid,
            warehouseId: warehouse[0].value,
            storeId: storeId || ""
        }
        getInventoryItemSummary(payload).then((res) =>
            setShow((prev) => { return { visible: true, info: res.responsePacket.data } })
        )
    }

    return Object.keys(groupedByItem).length > 0 ? (
        <div className="inventory-summary table-responsive ">
            <table className="customTable table">
                <thead>
                    <tr>
                        <th rowspan="2">SNO</th>
                        <th rowspan="2">Item</th>
                        {warehouses.map((warehouse) => (
                            <React.Fragment key={warehouse}>
                                <th colSpan="2">{warehouse}</th>
                            </React.Fragment>
                        ))}
                        {/* Hidden for now
                        <th rowspan="2">Aggregate Stock</th>
                        <th rowspan="2">Unit</th> */}
                    </tr>
                    <tr>
                        {/* <th></th>
                        <th></th> */}
                        {warehouses.map((warehouse) => (
                            <React.Fragment key={warehouse}>
                                {/* Packed Stock / Unit / Open Stock hidden for now
                                <th>Packed Stock</th>
                                <th>Unit</th>
                                <th>Open Stock</th> */}
                                <th>Total Stock</th>
                                <th>Unit</th>
                            </React.Fragment>
                        ))}
                        {/* <th></th>
                        <th></th> */}
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(groupedByItem).map(([itemId, item], index) => {
                        let aggregateStock = 0;
                        return (
                            <tr onClick={() => handleSowDetails(itemId)} key={itemId}>
                                <td>{index + 1}</td>
                                <td className="item-title-blue">{item.itemTitle}</td>
                                {warehouses.map((warehouse) => {
                                    const warehouseData = item.warehouses[warehouse] || {};
                                    aggregateStock += warehouseData.totalStockInOpenUnit || 0;
                                    return (
                                        <React.Fragment key={warehouse}>
                                            {/* Packed Stock / Unit / Open Stock hidden for now
                                            <td>{getFormattedNumber(warehouseData.currentStockBoxQuantity) || 0}</td>
                                            <td>{warehouseData.packUnitTitle || "-"}</td>
                                            <td>{getFormattedNumber(warehouseData.currentStockOpenQuantity) || 0}</td> */}
                                            <td>{getFormattedNumber(warehouseData.totalStockInOpenUnit) || 0}</td>
                                            <td>{warehouseData.packUnitTitle || "-"}</td>
                                        </React.Fragment>
                                    );
                                })}
                                {/* Aggregate Stock + Unit hidden for now
                                <td>{getFormattedNumber(aggregateStock)}</td>
                                <td>{item.warehouses[warehouses[0]]?.itemUnitTitle || "-"}</td> */}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <Modal show={show?.visible} onHide={() => setShow(() => { return { visible: false, info: [] } })} size="xl">
                <div className="d-flex justify-content-between mt-3 mx-4">
                    <h3 className="font-size-20">Item Report</h3>
                    {/* <button className="btn btn-primary py-2" onClick={handlePrint}>
            <LocalPrintshopOutlinedIcon />
        </button> */}
                </div>
                <Modal.Body>
                    <div
                        className="custom-table-div standardTable"
                        id="pdf"
                        style={{ width: "100%", margin: "15px", color: "black" }}
                    >
                        <hr style={{ backgroundColor: "#ececec" }} />
                        <div>
                            <table
                                style={{
                                    width: '100%',
                                    tableLayout: 'fixed',
                                    clear: 'both',
                                }}
                                className='pcs-label'
                                id='itemTable'
                                cellSpacing={0}
                                cellPadding={0}
                                border='1px solid black'
                            >
                                <thead>
                                    <tr>
                                        <td style={{ width: '10%' }}>S.No.</td>
                                        <td style={{ width: '100%' }}>Item</td>
                                    </tr>

                                </thead>
                                <tbody >
                                    {show?.info.map((item, index) => {
                                        return (
                                            <tr style={{ marginLeft: "8px" }} key={index}>
                                                <td><div style={{ width: "100%", marginLeft: "20px" }}>{index + 1}</div></td>
                                                <td>
                                                    <span style={{ borderBottom: "1px solid black" }}>{item.itemTitle}</span>
                                                    <table style={{
                                                        width: '100%',
                                                        tableLayout: 'fixed',
                                                        clear: 'both',
                                                        marginTop: "10px"
                                                    }}
                                                        className='pcs-label'
                                                        id='itemTable'
                                                        cellSpacing={0}
                                                        cellPadding={0}
                                                        border='1px solid black'>
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: "12%" }}>Batch No</th>
                                                                <th style={{ width: "12%" }}>Batch Qty</th>
                                                                <th style={{ width: "12%" }}>Mfg Date</th>
                                                                <th style={{ width: "12%" }}>Exp Date</th>
                                                                <th style={{ width: "12%" }}>Store</th>
                                                                <th style={{ width: "12%" }}>Rack</th>
                                                                <th style={{ width: "12%" }}>Cell</th>
                                                                <th style={{ width: "12%" }}>Pallete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontWeight: "400" }}>
                                                            {(item?.isMultipleBatchDetails == false) ?
                                                                <>
                                                                    <tr key={index}>
                                                                        <td>{item?.batchNumber}</td>
                                                                        <td>{item?.batchQuantity}</td>
                                                                        <td>{item?.batchManufacturingDate}</td>
                                                                        <td>{item?.batchExpiredDate}</td>
                                                                        <td>{item?.storeTitle}</td>
                                                                        <td>{item?.rackTitle}</td>
                                                                        <td>{item?.cellTitle}</td>
                                                                        <td>{item?.palletTitle}</td>
                                                                    </tr>
                                                                </>
                                                                : <>
                                                                    {item?.batchMultipleDetails && JSON.parse(item?.batchMultipleDetails).map((e, index) => {
                                                                        return <tr key={index}>
                                                                            <td>{e?.batchNumber}</td>
                                                                            <td>{e.batchQuantityAvailable?e.batchQuantityAvailable<0?0:e.batchQuantityAvailable:e?.batchQuantitySelected}</td>
                                                                            <td>{e?.batchManufacturingDate}</td>
                                                                            <td>{e?.batchExpiredDate}</td>
                                                                            <td>{e?.storeTitle}</td>
                                                                            <td>{e?.rackTitle}</td>
                                                                            <td>{e?.cellTitle}</td>
                                                                            <td>{e?.palletTitle}</td>
                                                                        </tr>
                                                                    })}
                                                                </>}

                                                        </tbody>
                                                    </table>
                                                </td>

                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>
    ) : (
        <>No Record found</>
    );
};


export default InventorySummary;
